module.exports = __webpack_public_path__ + "img/1440.d49d00a1.jpg";